//-------------------------------------------
//global variables
window.screenXL = 1300;
window.screenLG = 1100;
window.screenMD = 992;
window.screenSM = 767;
window.screenXS = 480;
window.screenUS = 380;
(function ($) {
    $(document).ready(function(){
        //-------------------------------------------
        //true window dimensions
        function viewport() {
            var e = window, a = 'inner';
            if (!('innerWidth' in window )) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
        }
        //-------------------------------------------
        //toggle body class
        function fnToggle(cl,action) {
            var $activeClass = cl,
                $elClass = $('body');
            if(action=='close'){
                $elClass.removeClass($activeClass);
            }else{
                if($elClass.hasClass($activeClass)==true){
                    $elClass.removeClass($activeClass);
                }else{
                    $elClass.addClass($activeClass);
                }
            }
        }
        //-------------------------------------------
        //link
        $(document).on('click','*[data-link]',function(){
            window.location.href = $(this).attr('data-link');
        });
        //-------------------------------------------
        //mobile nav
        // function fnToggleNav(action) {
        //     fnToggle('nav-active',action);
        // }
        // $(document).on('click','#header .nav-toggle',function(e){
        //     e.preventDefault();
        //     fnToggleNav();
        // });
        // $(document).keyup(function(e) {
        //     if (e.keyCode === 27){
        //         fnToggleNav('close');
        //     }
        // });
        //-------------------------------------------
        //tooltip
        $('.js-tooltip').tooltipster({
            maxWidth: 340,
            contentAsHTML: true,
            interactive: true,
            trigger: 'custom',
            triggerOpen: {
                click: true,
                mouseenter: true,
                touchstart: true
            },
            triggerClose: {
                mouseleave: true,
                click: true,
                scroll: true,
                tap: true
            }
        });
        //-------------------------------------------
        //nouisliders
        $('.js-nouislider').each(function () {
            var html5Slider = this;
            if($(this).closest('.with-input').length){
                noUiSlider.create(html5Slider, {
                    start: parseFloat($(this).data('start')),
                    step: $(this).data('step') ? parseFloat($(this).data('step')) : 1,
                    connect: [true, false],
                    range: {
                        'min': $(this).data('min'),
                        'max': $(this).data('max')
                    },
                    format: wNumb({
                        decimals: $(this).data('decimals') ? $(this).data('decimals') : 0,
                        thousand: ''
                    }),
                });
                var inputFormatSel = $(this).closest('.with-input').find('.value-input'),
                    inputFormat = inputFormatSel[0];
                inputFormatSel.attr({
                    min: $(this).data('min'),
                    max: $(this).data('max'),
                    step: $(this).data('step'),
                    value: $(this).data('start')
                });
                html5Slider.noUiSlider.on('update', function (values, handle) {
                    inputFormat.value = values[handle];
                    $(html5Slider).change();
                    // $(inputFormat).change();
                });
                inputFormat.addEventListener('change', function () {
                    html5Slider.noUiSlider.set(this.value);
                });
            }
            if($(this).closest('.summary-believe').length){
                noUiSlider.create(html5Slider, {
                    start: $(this).data('start'),
                    step: $(this).data('step'),
                    connect: [true, false],
                    range: {
                        'min': $(this).data('min'),
                        'max': $(this).data('max')
                    },
                    format: wNumb({
                        decimals: 1,
                        thousand: '',
                        suffix: '%',
                    })
                });
                var inputFormatSel = $(this).closest('.summary-believe').find('.value'),
                    inputFormat = inputFormatSel[0],
                    $inputHidden = $(this).closest('.summary-believe').find('.value-input');
                inputFormatSel.attr({
                    min: $(this).data('min'),
                    max: $(this).data('max'),
                    step: $(this).data('step'),
                    value: $(this).data('start')
                });
                html5Slider.noUiSlider.on('update', function (values, handle) {
                    inputFormat.innerHTML  = values[handle];
                    $inputHidden.val(values[handle]).change();
                });
            }
        });
        //-------------------------------------------
        //project selection
        $('.section-projects-list .el-project').on('click',function(){
            var $this=$(this),
                $par=$this.closest('.section-projects-list'),
                $input=$par.find('.section-projects-list__input'),
                $clThis='el-project',
                $clActive='active',
                $clSel='item-selected',
                $clNotSel='no-item-selected';
            if($this.hasClass($clActive)){
                $par.removeClass($clSel);
                $par.addClass($clNotSel);
                $this.removeClass($clActive);
                $input.val('').change();
            }else{
                $par.removeClass($clNotSel);
                $par.addClass($clSel);
                $par.find('.'+$clThis+'.'+$clActive).removeClass($clActive);
                $this.addClass($clActive);
                $input.val($(this).attr('data-id')).change();
            }
        });
        //-------------------------------------------
        //project detail slider
        $('.el-project-detail .slider').slick({
            arrows: false,
            autoplaySpeed: 1000,
            dots: true,
            draggable: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: true,
            customPaging: function(slider,i){
                return '<a class="tab"></a>';
            }
        });
        /*-------------------------------------------*/
        /*--magnificPopup gallery with zoom
        /*--*/
        $('.el-project-detail .slider').each(function() { // the containers for all your galleries
            $(this).magnificPopup({
                delegate: '.slick-slide:not(.slick-cloned) a',
                type: 'image',
                gallery: {
                    enabled: true,
                    tCounter: '<span class="mfp-counter">%curr% / %total%</span>'
                }
            });
        });
        //-------------------------------------------
    });
})(jQuery)